import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'

export const Container = forwardRef(function Container(
  { className, ...props },
  ref,
) {
  const classNames = ['mx-auto max-w-6xl px-6', className]
    .filter(Boolean)
    .join(' ')

  return <div className={classNames} {...props} ref={ref} />
}) as Polymorphic<'div'>
